<template>
  <div v-if="flexExtras.length">
    <div class="flex items-center justify-between my-2 lg:my-8">
      <h3 class="heading-3 w-full">
        {{ $t("shared.rest_easy_with_flexi_avm") }}
      </h3>
    </div>

    <v-radio-group v-model="flexExtraSelected" column>
      <div v-for="extra in flexExtras" :key="extra.id">
        <app-box-booking class="px-6 box">
          <v-radio :value="0" class="text-xl" color="secondary">
            <template v-slot:label>
                <div class="flex flex-col justify-start items-start lg:ml-8">
                  <p class="text-turquoiseBlue font-black text-lg lg:text-xl mb-4">{{ appConfig === "avm" ? $t("flexible_avm.list_1") : $t("basic_insurance") }}</p>
                  <div v-if="isPackFlight">
                    <ul class="list-disc">
                      <li class="list-item">{{ $t("flexible_avm.basic.list_1") }}</li>
                      <li class="list-item">{{ $t("flexible_avm.basic.list_2") }}</li>
                      <li class="list-item">{{ $t("flexible_avm.basic.list_3") }}</li>
                      <li class="list-item">{{ $t("flexible_avm.basic.list_4") }}</li>
                      <li class="list-item">{{ $t("flexible_avm.basic.list_5") }}</li>
                    </ul>
                  </div>
                  <div v-else>
                    <ul class="list-disc">
                      <li class="list-item">{{ $t("flexible_avm.list_2_1") }}</li>
                      <li class="list-item">{{ $t("flexible_avm.list_2_2") }}</li>
                    </ul>
                  </div>
                </div>
            </template>
          </v-radio>
          <div>
            <a v-if="isPackFlight" class="more-details-button mt-5 lg:ml-8 hover:underline" href="/pdfs/seguro-basico.pdf" download>
              {{ $t('flexible_avm.conditions.consult_conditions') }}
            </a>
          </div>
        </app-box-booking>

        <app-box-booking class="px-6 box">
          <v-radio :value="extra" class="text-xl" color="secondary">
            <template v-slot:label>
              <div class="flex flex-col justify-start items-start lg:ml-8">
                <p class="text-turquoiseBlue font-black text-lg lg:text-xl mb-4">{{ extra.title }}</p>
                <div v-for="(item) in Object.values(extra.description)" :key="index">
                  <ul class="list-disc">
                    <li class="list-item">{{ item }}</li>
                  </ul>
                </div>
                <!-- <div>
                  <ul class="list-disc">
                    <li class="list-item">{{ $t("flexible_avm.list_1_1") }}</li>
                    <li class="list-item">{{ $t("flexible_avm.list_1_2") }}</li>
                    <li class="list-item">{{ $t("flexible_avm.list_1_3") }}</li>
                  </ul>
                </div> -->
                <div v-if="extra.price > 0" class="font-bold mt-4 flex justify-end mr-8 w-full">
                  + {{ (extra.price / travelersTotal) | currency }}/{{
                    $tc("shared.passenger", 1)
                  }}
                </div>
                <div v-else class="font-bold mt-4 flex justify-end mr-8 w-full">
                  {{ $t('more_days_landing.included') }}
                </div>
              </div>
            </template>
          </v-radio>
          <div>
            <a v-if="isPackFlight" class="more-details-button mt-5 lg:ml-8 hover:underline" href="/pdfs/seguro-premium.pdf" download>
              {{ $t('flexible_avm.conditions.consult_conditions') }}
            </a>
          </div>
        </app-box-booking>
      </div>
    </v-radio-group>

    <div v-if="!isPackFlight" class="doubts cursor-pointer inline-block">
      <a href="/terminos-y-condiciones-flex" target="_blank" class="text-sm">{{ $t("flexible_avm.accept_terms") }}</a>
    </div>

    <popup>
      <div class="flex flex-col py-3">
        <div class="flex justify-between items-start">
          <span class="text-2xl font-bold">Flexi AVM</span>
          <v-icon color="black" @click="closePopup()">mdi-close</v-icon>
        </div>
        <div class="content">
          <div class="mt-3">
            <span class="secondary--text font-bold">{{ $t("flexible_avm.conditions.service_usage") }}</span>
            <p class="mt-2">{{ $t("flexible_avm.conditions.service_usage_description") }}</p>
          </div>
          <div class="mt-3">
            <span class="secondary--text font-bold">{{ $t("flexible_avm.conditions.what_can_i_do") }}</span>
            <p class="mt-2">{{ $t("flexible_avm.conditions.what_can_i_do_description") }}</p>
          </div>
          <div class="mt-3">
            <span class="secondary--text font-bold">{{ $t("flexible_avm.conditions.can_i_exchange_coupon") }}</span>
            <p class="mt-2">{{ $t("flexible_avm.conditions.can_i_exchange_coupon_description") }}</p>
          </div>
          <div class="mt-3">
            <span class="secondary--text font-bold">{{ $t("flexible_avm.conditions.can_i_cancel_reservation") }}</span>
            <p class="mt-2">{{ $t("flexible_avm.conditions.can_i_cancel_reservation_description") }}</p>
          </div>
          <div class="mt-3">
            <span class="secondary--text font-bold">{{ $t("flexible_avm.conditions.what_if_schedule_change") }}</span>
            <p class="mt-1">{{ $t("flexible_avm.conditions.if_flex_avm") }}</p>
            <p class="mt-1">{{ $t("flexible_avm.conditions.we_will_help_you_and_can_cancel") }}</p>
            <p class="mt-1">{{ $t("flexible_avm.conditions.if_no_flex_avm") }}</p>
            <p class="mt-1">{{ $t("flexible_avm.conditions.modify_more_than_three_hours") }}</p>
            <p class="mt-1">{{ $t("flexible_avm.conditions.modify_less_than_three_hours") }}</p>
          </div>
          <div class="mt-3">
            <p>{{ $t("flexible_avm.conditions.still_doubts") }} <a href="/terminos-y-condiciones-flex"
                class="secondary--text" target="_blank">{{ $t("flexible_avm.conditions.terms") }}</a></p>
          </div>
        </div>
      </div>
    </popup>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import {
  GET_FLEX_EXTRAS,
  GET_FLEX_EXTRA_SELECTED,
} from "../store/booking/getter-types";
import { SET_FLEX_EXTRA_SELECTED } from "../store/booking/mutation-types";
import {
  NIGHTS_GET_IS_PACK_FLIGHT
} from "../store/nights/getter-types";
import Popup from "./Popup/Popup";

export default {
  props: {
    travelersTotal: Number
  },
  components: {
    Popup
  },
  data() {
    return {
      appConfig: window.appConfig,
      showDetails: false,
      showBasicDetails: false,
    };
  },

  computed: {
    ...mapGetters({
      isPackFlight: NIGHTS_GET_IS_PACK_FLIGHT,
      getFlexExtras:GET_FLEX_EXTRAS
    }),
    flexExtras() {
      if (this.isPackFlight) {
        return [
          {
            id: 0,
            title: this.$t("premium_insurance"),
            packFlight: true,
            price: 110 * this.travelersTotal,
            description: {
              1:this.$t("flexible_avm.premium.list_1"),
              2:this.$t("flexible_avm.premium.list_2"),
              3:this.$t("flexible_avm.premium.list_3"),
              4:this.$t("flexible_avm.premium.list_4"),
              5:this.$t("flexible_avm.premium.list_5"),
              6:this.$t("flexible_avm.premium.list_6"),

            }
          }
        ]
      } else {
        return this.getFlexExtras;
      }
    },
    flexExtraSelected: {
      get() {
        return this.$store.getters[GET_FLEX_EXTRA_SELECTED];
      },
      set(value) {
        return this.$store.commit(SET_FLEX_EXTRA_SELECTED, value);
      }
    }
  },
  methods: {
    openPopup() {
      Event.$emit('open-popup');
    },
    closePopup() {
      Event.$emit('close-popup');
    },
    toggleDetails() {
      this.showDetails = !this.showDetails;
    },
    toggleBasicDetails() {
      this.showBasicDetails = !this.showBasicDetails;
    }
  }
};
</script>

<style lang="scss">
@import "../../sass/variables";

.more-details-button {
  color: $turquoiseBlue;
  cursor: pointer;
  margin-top: 8px;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}

.fade-enter,
.fade-leave-to {
  opacity: 0;
}
</style>
